import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import i18n from 'src/utils/translate';

import Button from 'src/components/buttons/button';
import FollowSuccessMessage from 'src/modules/community/shared/components/alert/followSuccessMessage';

import { showSignupModal, showModal } from 'src/modules/shared/modal/actions';
import { followCommunity } from 'src/modules/community/shared/actions';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Element, Section } from 'src/constants/footfall';
import modalTypes from 'src/constants/modalTypes';
import { showGuidelines } from 'src/modules/community/shared/components/communityGuidelinesModal';
import { userHasPermission } from 'src/utils/context';
import { setAlert } from 'src/typescript/components/alert/actions';

export const onWriteClick = async ({
  community,
  currentUser,
  followCommunity,
  showSignupModal,
  showModal,
  setAlert,
  trackingSection,
}) => {

  if (!currentUser) {
    showSignupModal({
      signupContext: {
        element: Element.WRITE,
        section: Section.COMMUNITY,
      },
      group: community,
    });
    trackFootfallEvent(Event.CLICKED, {
      clickType: 'sign-up',
      clickMetadata: { section: trackingSection, element: Element.WritePost },
    });
  } else if (!currentUser.followedCommunities.find(x => x.slug === community.slug)) {
    await showModal({
      modalProps: {
        accept: i18n.t('Join'),
        cancel: i18n.t('Cancel'),
        title: i18n.t('Write a post'),
        onAccept: async () => {
          await followCommunity(community, currentUser.userId, <FollowSuccessMessage communityName={community.name}/>);
          if (showGuidelines(community)) {
            await showModal({
              modalType: modalTypes.COMMUNITY_GUIDELINES,
              modalProps: {redirect: true},
            });
          } else {
            setTimeout(() => {
              window.location.href = `/${community.slug}/write`;
            }, 500);
          }
        },
        children: i18n.t('You need to join this community to be able to write a post or ask a question'),
      },
    });
  } else if (!userHasPermission(currentUser, 'CreatePost')) {
    setAlert(i18n.t('You have been restricted in this community. Please contact this community\'s administrator to find out why.'));
    return;
  } else if (showGuidelines(community)) {
    showModal({
      modalType: modalTypes.COMMUNITY_GUIDELINES,
      modalProps: {redirect: true},
    });
  } else {
    window.location.href = `/${community.slug}/write`;
  }
};

const WriteButton = ({
  community,
  currentUser,
  followCommunity,
  children,
  showSignupModal,
  setAlert,
  showModal,
  trackingSection,
}) => (
  <Button
    dataTestId="write-button"
    icon="pencil-1"
    onClick={() => onWriteClick({
      community,
      currentUser,
      followCommunity,
      showSignupModal,
      showModal,
      setAlert,
      trackingSection,
    })}
  >
    {children}
  </Button>
);

WriteButton.propTypes = {
  community: PropTypes.object.isRequired,
  trackingSection: PropTypes.string.isRequired,
  currentUser: PropTypes.object,
  followCommunity: PropTypes.func,
  setAlert: PropTypes.func,
  showModal: PropTypes.func,
  showSignupModal: PropTypes.func,
};

WriteButton.defaultProps = {
  currentUser: null,
  showSignupModal: () => {},
  showModal: () => {},
  followCommunity: () => {},
};

export default connect(null, { showSignupModal, showModal, followCommunity, setAlert })(WriteButton);
